import React, { Component } from 'react';
import { IngresoMenu } from '../../../shared/MenuItems';

import imagine from "../../../assets/img/sidebar-4.jpg";

import Inscripcion from './Contenido/Inscripción';
import FooterContent from "../Index/FooterContent";

class Ingreso extends Component {
    constructor (props) {
        super (props);
        this.scrollIni();
    }

    scrollIni = () => {
        window.scroll({
            top: 0,
            behavior: 'smooth'
        });
    }
    
    scroll = (id) => (e) => {
        window.scroll({
            top: (document.getElementById(id).offsetTop) - 40,
            behavior: 'smooth'
        });
    }

    sidebar = () => {
        let ContentMenu = (
            IngresoMenu.map(option => (
                <li className = "menu-items fuente-monserrat"
                    onClick = {this.scroll(option.idScroll)}
                    style={{paddingLeft:15, paddingTop: 14, paddingBottom: 14, fontSize: option.font}} key={option.id}>
                    {/* <img height={35} width="auto" src={option.icon} /> */} {option.nombre}
                </li>
            ))
        )

        const sidebarBackground = {
            backgroundImage: "url(" + imagine + ")",
        };

        return (
            <div
                id="sidebar"
                className="sidebar"
                data-color="custom2" /* para cambiar el scss buscar $new-custom */
                data-image={imagine}
                style = {{zIndex: 4, boxShadow: "1px 1px 3px #000", paddingTop:70}}
            >
                <div className="sidebar-background" style={sidebarBackground}/>
                <div className="sidebar-wrapper">
                    <ul className="nav">
                        {ContentMenu}
                    </ul>
                </div>
            </div>
        )
    }

    contenido = () => (
        <div className = "custom-card-fix">
            <Inscripcion />
        </div>
    )

    render() {
        return(
            <React.Fragment>
                <div className="home-content">
                    <div className="wrapper" style={{backgroundColor: "rgba(255,255,255, 0)"}}>
                        {this.sidebar()}
                        <div id="main-panel" className="main-panel" ref="mainPanel">
                            {this.contenido()}
                            <FooterContent/>
                        </div>
                    </div>
                    
                </div>
            </React.Fragment>
        );
    }
}
 
export default Ingreso;


// WEBPACK FOOTER //
// ./src/site/Componentes/Ingreso/Ingreso.jsx